import * as yup from "yup";

/** The upload file interface. Extends the JS File interface. */
export interface UploadFile extends File {
  /** The file ID - UUID (v4) */
  id: string;
  /** SOP Instance UID (0008,0018) - DICOM files only */
  inst: string;
}

/** The form validation schema for the upload file. */
export const UploadFileValidation = yup.object({
  id: yup.string().required(),
});

/**
 * Return the object URL for the upload file.
 * @param file The upload file.
 * @returns The object URL.
 */
export const getUploadFileObjectURL = (
  file: UploadFile
): string | undefined => {
  if (file === undefined) return undefined;
  return URL.createObjectURL(file);
};
